import { render, staticRenderFns } from "./BesoinsIJH.vue?vue&type=template&id=1c42d392&scoped=true&"
import script from "./BesoinsIJH.vue?vue&type=script&lang=js&"
export * from "./BesoinsIJH.vue?vue&type=script&lang=js&"
import style1 from "./BesoinsIJH.vue?vue&type=style&index=1&id=1c42d392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42d392",
  null
  
)

export default component.exports